import React from 'react'
import { useNavigate } from 'react-router-dom'
import Header from '../../components/Header'
import Button from '../../components/Button'
import notFoundImg from '../../assets/not-found.png'

const NotFound: React.FC = () => {
  const navigate = useNavigate()

  return (
    <>
      <Header />
      <div className="mx-auto my-[35px] flex max-w-[600px] flex-col items-center px-[5px] max-[766px]:max-w-[500px]">
        <div className="flex min-h-[400px] w-full flex-col items-center justify-center rounded-[8px] bg-white p-[30px_25px] shadow-[0px_2px_4px_rgba(0,0,0,0.05),0px_6px_12px_rgba(61,69,67,0.05)] mx-[5px]">
          <img src={notFoundImg} alt="404 error" className="w-full" />
          <h3 className="mx-auto my-[18px] w-[80%] text-center text-[20px] max-[766px]:text-[16px]">
            Página não encontrada.
          </h3>

          <Button type="button" color="blue" onClick={() => navigate(-1)}>
            VOLTAR
          </Button>
        </div>
      </div>
    </>
  )
}

export default NotFound
